<template>
  <aha-context-menu
    ref="content-slide-context-menu"
    :x="targetX"
    :y="targetY"
    :offsetX="offsetX"
    :offsetY="offsetY"
    :layerX="layerX"
    :layerY="layerY"
    :targetClick="targetClick"
    isMenuInCanvas
    :target="'slide-container'"
    class="content-right-click-menu"
  >
    <aha-context-menu-item
      @click="handleCopyBlock()"
      class="content-right-click-menu-item"
    >
      <div class="space-x-2">
        <aha-icon
          name="copy-b"
          class="text-base-70"
          width="24"
          height="24"
          viewBox="0 0 20 20"
        />
        <span>Copy</span>
      </div>
      <ContextMenuShortcutKeys keyName="c-key" />
    </aha-context-menu-item>
    <aha-context-menu-item
      @click="handleCutBlock()"
      class="content-right-click-menu-item"
    >
      <div class="space-x-2">
        <aha-icon
          name="cut"
          class="text-base-70"
          width="24"
          height="24"
          viewBox="0 0 20 20"
        />
        <span>Cut</span>
      </div>
      <ContextMenuShortcutKeys keyName="x-key" />
    </aha-context-menu-item>
    <aha-context-menu-item
      @click="handleDuplicateBlock()"
      class="content-right-click-menu-item"
      hasDivider
    >
      <div class="space-x-2">
        <aha-icon
          name="duplicate"
          class="text-base-70"
          width="24"
          height="24"
          viewBox="0 0 20 20"
        />
        <span>Duplicate</span>
      </div>
      <ContextMenuShortcutKeys keyName="d-key" />
    </aha-context-menu-item>
    <aha-context-menu-item
      @click="handleChangeBlockOrder('sendBackward')"
      class="content-right-click-menu-item"
    >
      <div class="space-x-2">
        <aha-icon
          name="send-backward"
          class="text-base-70"
          width="24"
          height="24"
          viewBox="0 0 20 20"
        />
        <span>Send backward</span>
      </div>
      <ContextMenuShortcutKeys keyName="b-key" />
    </aha-context-menu-item>
    <aha-context-menu-item
      @click="handleChangeBlockOrder('sendToBack')"
      class="content-right-click-menu-item"
    >
      <div class="space-x-2">
        <aha-icon
          name="send-to-back"
          class="text-base-70"
          width="24"
          height="24"
          viewBox="0 0 20 20"
        />
        <span>Send to back</span>
      </div>
      <ContextMenuShortcutKeys keyName="b-key" hasShiftKey />
    </aha-context-menu-item>
    <aha-context-menu-item
      @click="handleChangeBlockOrder('bringForward')"
      class="content-right-click-menu-item"
    >
      <div class="space-x-2">
        <aha-icon
          name="bring-forward"
          class="text-base-70"
          width="24"
          height="24"
          viewBox="0 0 20 20"
        />
        <span>Bring forward</span>
      </div>
      <ContextMenuShortcutKeys keyName="f-key" />
    </aha-context-menu-item>
    <aha-context-menu-item
      @click="handleChangeBlockOrder('bringToFront')"
      class="content-right-click-menu-item"
      hasDivider
    >
      <div class="space-x-2">
        <aha-icon
          name="bring-to-front"
          class="text-base-70"
          width="24"
          height="24"
          viewBox="0 0 20 20"
        />
        <span>Bring to front</span>
      </div>
      <ContextMenuShortcutKeys keyName="f-key" hasShiftKey />
    </aha-context-menu-item>

    <aha-context-menu-item
      @click="handleDeleteBlock()"
      class="content-right-click-menu-item"
    >
      <div class="space-x-2">
        <aha-icon
          name="delete2"
          class="text-base-70"
          width="24"
          height="24"
          viewBox="0 0 20 20"
        />
        <span>Delete</span>
      </div>
      <ContextMenuShortcutKeys keyName="delete-key" :hasControlKeys="false" />
    </aha-context-menu-item>
  </aha-context-menu>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import EventBus from '@/eventBus'
import utils from '@/util'
// import gaCategories from '@/constant/gaCategories'
import ContentSlideShortcutKeysMixin from '@/mixins/freestyle/ContentSlideShortcutKeysMixin'
import ContextMenuShortcutKeys from './ContextMenuShortcutKeys.vue'

class SVGPathElement extends HTMLElement {}

window.SVGPathElement = SVGPathElement

export default {
  components: {
    ContextMenuShortcutKeys,
  },
  mixins: [ContentSlideShortcutKeysMixin],
  props: {
    targetX: {
      type: Number,
      default: null,
    },
    targetY: {
      type: Number,
      default: null,
    },
    offsetX: {
      type: Number,
      default: null,
    },
    offsetY: {
      type: Number,
      default: null,
    },
    layerX: {
      type: Number,
      default: null,
    },
    layerY: {
      type: Number,
      default: null,
    },
    targetClick: {
      type: [HTMLSpanElement, HTMLImageElement, HTMLDivElement, HTMLCanvasElement,
        SVGPathElement, HTMLElement, HTMLParagraphElement, SVGTextElement, SVGSVGElement],
      default: null,
    },
  },
  data() {
    return {
      gaLabel: 'Canvas > Right click > Open canvas context menu',
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      plan: (state) => state.plan,
    }),
    ...mapState([
      'undoHistory',
      'redoHistory',
      'isBlockHistory',
      'isSyncing',
      'isDisableEditPresentation',
    ]),
    ...mapGetters(['selectedSlide']),
    isMacOS() {
      return utils.isMacOS()
    },
    controlKeyIcon() {
      if (this.isMacOS) {
        return '<aha-icon name="meta-key"/>'
      }
      return '<aha-icon name="ctrl-key"/>'
    },
  },
  mounted() {
    EventBus.$on('content-slide-right-click-menu: show', () => {
      this.$refs['content-slide-context-menu'].show()
    })
    EventBus.$on('content-slide-right-click-menu: hide', () => {
      this.$refs['content-slide-context-menu'].hide()
    })
  },
  destroyed() {
    EventBus.$off('content-slide-right-click-menu: show')
    EventBus.$off('content-slide-right-click-menu: hide')
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    ...mapActions([
      'undoAction',
      'redoAction',
    ]),
    handleCopyBlock() {
      this.$emit('copyBlock')
    },
    handleCutBlock() {
      this.$emit('cutBlock')
    },
    handleDuplicateBlock() {
      this.$emit('duplicateBlock')
    },
    handleChangeBlockOrder(command) {
      this.$emit('changeBlockOrder', command)
    },
    handleDeleteBlock() {
      this.$emit('deleteBlock')
    },
  },
}
</script>

<style lang="scss">
.content-right-click-menu {
  font-family: Nunito, sans-serif;
  .content-right-click-menu-item {
    display: flex !important;
    flex: none !important;
    font-size: 17px;
    padding: 0.5rem;
    justify-content: space-between;
    &:last-child {
      padding-bottom: 0.25rem !important;
    }
  }
  &::v-deep .container-shortcut-key .shortcut-key {
    background: #CECECE;
  }
  .context-menu-wrapper {
    min-width: 18rem;
  }
}
</style>
